import { Outlet, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Button, Space, Spin } from 'antd';
import { isMobile } from 'react-device-detect';
import { MENU_ITEM_ENUM, Menu } from '../Menu';
import { Suspense, useEffect, useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useStore } from '../../config/store';
import './Layout.scss';
const { Header, Sider, Content } = AntLayout;

export const Layout = () => {
  const [collapsed, setCollapsed] = useState(isMobile);
  const location = useLocation();

  const path = location.pathname.slice(1) as keyof typeof MENU_ITEM_ENUM;

  const { getInitialData, loaded } = useStore();

  useEffect(() => {
    getInitialData();
  }, []);

  if (!loaded) return <Spin />;

  return (
    <>
      <AntLayout style={{ minHeight: '100vh' }}>
        <Sider width={230} trigger={null} collapsible collapsed={collapsed} collapsedWidth="0">
          <Menu set={() => setCollapsed(true)} />
        </Sider>
        <AntLayout>
          <Header style={{ padding: 0, background: 'white' }}>
            <Space>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              <span style={{ fontWeight: 700 }}>{MENU_ITEM_ENUM[path]?.toUpperCase() || ''}</span>
            </Space>
          </Header>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
            }}
          >
            <Suspense fallback={<div>...</div>}>
              <Outlet />
            </Suspense>
          </Content>
        </AntLayout>
      </AntLayout>
    </>
  );
};
